module.exports = __webpack_public_path__ + "img/quikr-guide.270d73f8.png";